import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, Type } from "@angular/core";
import { Subscription } from 'rxjs';
import {  GetSaldoAvansaZbirnoQuery, GetSaldoFaktureZbirnoQuery, IRacunFilterDto,
  IRacunSaldoResult, ISaldoAvansaZbirnoResult, ISaldoFaktureZbirnoResult, RacunFilterDto,
  RacuniClient, TipRacuna,
  VrstaRacuna
} from "@kodit/core/data-api";
import { ActivatedRoute } from '@angular/router';
import { RacunFilterService } from '../racun-filter/racun-filter.service';
import { AlertService, GodinaRacunaDropdownService } from "@kodit/core/services";
import { RacunSaldoService } from './racun-saldo.service';
import {
  SlanjePodsetnikaFormComponent
} from "../../../../../moduli/stranka/src/lib/slanje-podsetnika-form/slanje-podsetnika-form.component";
import { DynamicDialogConfig, DynamicDialogService } from "@kodit/core/shared-ui";
import { DialogSize } from "../../../../../shared-ui/src/lib/dialogs/dynamic-dialog/dynamicdialog-config";
import { SaldoPlacenoData } from '../../../../../shared-ui/src/lib/pipes/saldo-placeno.pipe';
import { take } from "rxjs/operators";

@Component({
  selector: 'kodit-racun-saldo',
  templateUrl: './racun-saldo.component.html',
  styleUrls: ['./racun-saldo.component.scss'],
})
export class RacunSaldoComponent implements OnInit, OnDestroy, OnChanges {
  private _subs: Subscription;

  saldoFakture: ISaldoFaktureZbirnoResult;
  saldoAvansa: ISaldoAvansaZbirnoResult;
  filters: IRacunFilterDto;
  isLoading = true;
  displayPodsetnikZaPlacanjeBtn = false;
  saldoPlacenoData: SaldoPlacenoData;

  dialogConfig: DynamicDialogConfig = new DynamicDialogConfig(DialogSize.SMALL);

  strankaId?: number;
  @Input() vrstaRacuna: VrstaRacuna;
  @Input() tipRacuna: TipRacuna;

  constructor(
    private _client: RacuniClient,
    private _route: ActivatedRoute,
    private _filterService: RacunFilterService,
    private _dialogService: DynamicDialogService,
    private _service: RacunSaldoService,
    private _godinaService: GodinaRacunaDropdownService,
    private _alertServc: AlertService,
  ) {
    this._subs = new Subscription();

    this._route.params.subscribe((params) => {
      if (params['strankaId']) {
        this.strankaId = Number.parseInt(params['strankaId']);
      }
    });
  }

  ngOnInit(): void {
    this._applyFiltersAndLoad();

    this._subs.add(
      this._godinaService.getForm().valueChanges.subscribe(() => {
        this._filterService.get().pipe(take(1)).subscribe(filters => {
          this._applyLoad(filters);
        });
      })
    );

    this._subs.add(
      this._service.getShouldReload().subscribe((res) => {
        if (res) {
          this._applyLoad();
        }
      })
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    // if (changes['tipRacuna']?.currentValue !== changes['tipRacuna']?.previousValue) {
    //   if (changes['tipRacuna'].currentValue === TipRacuna.AVANSNI_RACUN ||
    //     changes['tipRacuna'].previousValue === TipRacuna.AVANSNI_RACUN) {
    //     // menjamo samo ako se prebacujemo na ili sa AR
    //     this._applyFiltersAndLoad();
    //   }
    // }
  }

  private _load() {
    this.isLoading = true;
    this._loadFakturaSaldo();
  }

  private _loadFakturaSaldo() {
    this._subs.add(
      this._client
        .getSaldoZbirno(this.filters as GetSaldoFaktureZbirnoQuery)
        .subscribe((res) => {
          this.saldoFakture = res.data;
          this.displayPodsetnikZaPlacanjeBtn =
            !!this.strankaId && this.saldoFakture.vanValuteIznos > 0;
          this._loadAvansSaldo();
        })
    );
  }

  private _loadAvansSaldo() {
    this._subs.add(
      this._client
        .getSaldoAvansaZbirno(this.filters as GetSaldoAvansaZbirnoQuery)
        .subscribe((res) => {
          this.saldoAvansa = res.data;
          this.isLoading = false;
          this.saldoPlacenoData = {
            saldoFakture: {
              cashflow: this.saldoFakture.cashflow,
              finansijskiPromet: this.saldoFakture.finansijskiPromet
            }
          }
        })
    );
  }

  private _applyLoad(filters?: string) {
    if (filters) {
      this.filters = JSON.parse(filters);
      this.filters.strankaId = this.strankaId;
      this.filters.vrstaRacuna = this.vrstaRacuna;
    } else {
      this.filters = new RacunFilterDto({
        vrstaRacuna: this.vrstaRacuna,
        strankaId: this.strankaId,
      });
    }
    this._load();
  }

  ngOnDestroy() {
    this._subs.unsubscribe();
  }

  protected readonly VrstaRacuna = VrstaRacuna;
  public readonly TipRacuna = TipRacuna;

  handlePodsetnikZaPlacanje() {
    this.dialogConfig.header = 'Slanje podsetnika';

    this._filterService.get()
      .pipe(take(1))
      .subscribe(filterJson => {

        const filter: IRacunFilterDto | null =
          filterJson ? JSON.parse(filterJson) : null;

        this.dialogConfig.data = {
          strankaId: this.strankaId,
          filter: filter,
          sendTo: [],
          sendCc: [],
        };

        this.dialogConfig.customSubmitButton = {
          icon: 'fas fa-paper-plane',
          label: 'Pošalji',
        };

        this.openDialog(SlanjePodsetnikaFormComponent);
      });
  }

  openDialog(formType: Type<SlanjePodsetnikaFormComponent>): void {
    const ref = this._dialogService.open(formType, this.dialogConfig);
    this._subs.add(
      ref.onClose.subscribe((dto: any) => {
        if (dto) {
          console.log(dto);
        }
      })
    );
  }

  private _applyFiltersAndLoad() {
    this._subs.add(
      this._filterService.get().subscribe((filters) => {
        this._applyLoad(filters);
      })
    );
  }

  handleRefresh() {
    this.isLoading = true;
    this._subs.add(this._client.refreshSaldoViews().subscribe(res => {
      this._alertServc.addSuccessMsg(res.data);
      this.isLoading = false;
    }))
  }
}
